import React, { useEffect } from "react";
import useViewerItemsVisibilityContext from "@/services/context/viewer/items-visibility/use-viewer-items-visibility-context.ts";
import useViewerContext from "@/services/context/viewer/instance/use-viewer-context";
import ViewerCanvas from "@/services/context/viewer/instance/viewer-canvas.tsx";

export const MeasureOverview3dViewerContainer: React.FC = () => {
    const { viewer, isLoading } = useViewerContext();
    const { visibleItems, subscribeVisibilityChanged } = useViewerItemsVisibilityContext();

    useEffect(() => {
        if (viewer == null || isLoading || visibleItems.length === 0) return;

        // Boomer models load hidden, including when replacing an existing model.
        viewer.showItems(visibleItems).catch((error: unknown) => {
            console.error("Erreur pendant la restauration de la visibilité des modèles", error);
        });
    }, [viewer, isLoading, visibleItems]);

    useEffect(() => subscribeVisibilityChanged(async ({ action, items }) => {
        if (viewer == null) return;

        if (action === "add") {
            await viewer.showItems(items);
        }

        if (action === "remove") {
            await viewer.hideItems(items);
        }
    }), [viewer, subscribeVisibilityChanged]);

    return (
        <div className='absolute inset-0'>
            <ViewerCanvas />
        </div>
    );
};

export default MeasureOverview3dViewerContainer;
